module.exports = __webpack_public_path__ + "img/1557614082730827780.9c9c76d8.png";